export default "__VITE_PUBLIC_ASSET__5f66497d__"